import { XDEFIAdapter } from '@shapeshiftoss/hdwallet-xdefi'
import { XDEFIIcon } from 'components/Icons/XDEFIIcon'

export const XDEFIConfig = {
  adapter: XDEFIAdapter,
  icon: XDEFIIcon,
  name: 'XDEFI',
}
